var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75673 20.1667C7.33626 20.1667 8.61673 18.8862 8.61673 17.3067C8.61673 15.7271 7.33626 14.4467 5.75673 14.4467C4.17719 14.4467 2.89673 15.7271 2.89673 17.3067C2.89673 18.8862 4.17719 20.1667 5.75673 20.1667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1034 15.4V4.21669C19.1034 1.83336 17.6092 1.50336 16.0967 1.91586L10.3767 3.47419C9.3317 3.75836 8.6167 4.58336 8.6167 5.77502V7.76419V9.10253V17.2975",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2433 18.26C17.8228 18.26 19.1033 16.9795 19.1033 15.4C19.1033 13.8204 17.8228 12.54 16.2433 12.54C14.6638 12.54 13.3833 13.8204 13.3833 15.4C13.3833 16.9795 14.6638 18.26 16.2433 18.26Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6167 8.72664L19.1034 5.86664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.b415433fa2fa47126303b8ad3783f511.svg";
export { ForwardRef as ReactComponent };